import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularStakeTransaction: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_stake-transaction"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="stake-transaction icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M3.81153 15.4809L14.8713 4.40952H12.2936C11.9974 4.40952 11.7573 4.16937 11.7573 3.87312C11.7573 3.57688 11.9974 3.33673 12.2936 3.33673H16.6673V7.75044C16.6673 8.04668 16.4272 8.28684 16.1309 8.28684C15.8347 8.28684 15.5945 8.04668 15.5945 7.75044V5.20458L4.56993 16.2407C4.36048 16.4504 4.02098 16.4504 3.81153 16.2407C3.60194 16.0309 3.60194 15.6907 3.81153 15.4809Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.02075 6.18254C9.02075 7.75489 7.7475 9.02914 6.17737 9.02914C4.60723 9.02914 3.33398 7.75489 3.33398 6.18254C3.33398 4.61018 4.60723 3.33594 6.17737 3.33594C7.7475 3.33594 9.02075 4.61018 9.02075 6.18254ZM6.17737 7.95634C7.15392 7.95634 7.94798 7.16351 7.94798 6.18254C7.94798 5.20156 7.15392 4.40873 6.17737 4.40873C5.20082 4.40873 4.40676 5.20156 4.40676 6.18254C4.40676 7.16351 5.20082 7.95634 6.17737 7.95634Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.6673 13.838C16.6673 15.4019 15.4009 16.6693 13.8392 16.6693C12.2775 16.6693 11.0111 15.4019 11.0111 13.838C11.0111 12.2741 12.2775 11.0067 13.8392 11.0067C15.4009 11.0067 16.6673 12.2741 16.6673 13.838ZM13.8392 15.5965C14.8073 15.5965 15.5945 14.8105 15.5945 13.838C15.5945 12.8654 14.8073 12.0795 13.8392 12.0795C12.8711 12.0795 12.0839 12.8654 12.0839 13.838C12.0839 14.8105 12.8711 15.5965 13.8392 15.5965Z"
        />
      </svg>
    </span>
  );
};

export { RegularStakeTransaction };
